import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import WebIcon from 'src/_shared/components/WebIconComponent.jsx';
import { ml } from 'src/_shared/services/utils.js';
import { getMobileTabs, isTabActive } from './mobileTabs.js';

const ACTIVE_COLOR = 'var(--menu-color, var(--cello))';
const INACTIVE_COLOR = '#6b7280';

/**
 * Bottom tab bar shown only inside the ERIN mobile shell (ERIN-8561). The
 * shell runs the page edge to edge, so the bar pads itself by the
 * home-indicator inset (see _shell.scss). "More" opens the regular side menu.
 */
export default function MobileTabBar({ currentUser, onMore }) {
	const { pathname } = useLocation();
	const allMultiLingualData = useSelector(
		(state) => state?.dashboard?.allMultiLingualData
	);
	const tabs = getMobileTabs(currentUser);
	if (tabs.length === 0) return null;

	return (
		<nav className="mobile-tab-bar" aria-label="Main">
			{tabs.map((tab) => {
				const active = isTabActive(pathname, tab.link, tab.key);
				return (
					<Link
						key={tab.key}
						to={tab.link}
						className={active ? 'active' : ''}
						aria-current={active ? 'page' : undefined}
					>
						<WebIcon
							name={tab.icon}
							size={22}
							color={active ? ACTIVE_COLOR : INACTIVE_COLOR}
						/>
						<span className="tab-title">
							{tab.translate === false
								? tab.title
								: ml(tab.title, currentUser, allMultiLingualData)}
						</span>
					</Link>
				);
			})}
			<button type="button" onClick={onMore}>
				<span className="bars" aria-hidden="true">
					<span className="bar" />
					<span className="bar" />
					<span className="bar" />
				</span>
				<span className="tab-title">
					{ml('More', currentUser, allMultiLingualData)}
				</span>
			</button>
		</nav>
	);
}
